enum TrackStatus {
  UNKNOWN = 'UNKNOWN',
  TRANSIT = 'TRANSIT',
  DELIVERED = 'DELIVERED',
  FAILURE = 'FAILURE',
  RETURNED = 'RETURNED',
  PRE_TRANSIT = 'PRE_TRANSIT',
}

type JSONTrack = {
  object_created: string;
  object_updated: string;
  object_id: string;
  status: string;
  status_details: string;
  status_date: string;
  location: Location;
};

type Track = {
  objectCreated: string;
  objectUpdated: string;
  objectId: string;
  status: TrackStatus;
  statusDetails: string;
  statusDate: string;
  location: Location;
};

type Location = {
  city: string;
  state: string;
  zip: string;
  country: string;
};

function fromJSON(jsonTrack: JSONTrack): Track {
  return {
    objectCreated: jsonTrack.object_created,
    objectUpdated: jsonTrack.object_updated,
    objectId: jsonTrack.object_id,
    status: <TrackStatus>jsonTrack.status,
    statusDetails: jsonTrack.status_details,
    statusDate: jsonTrack.status_date,
    location: {
      city: jsonTrack.location.city,
      state: jsonTrack.location.state,
      zip: jsonTrack.location.zip,
      country: jsonTrack.location.country,
    },
  };
}

type JSONTransactionSearchTrack = Omit<JSONTrack, 'location'> & { location?: Location | null };
type TransactionSearchTrack = Omit<Track, 'location'> & { location?: Location | null };

function transactionSearchTrackFromJSON(
  jsonTrack: JSONTransactionSearchTrack,
): TransactionSearchTrack {
  return {
    objectCreated: jsonTrack.object_created,
    objectUpdated: jsonTrack.object_updated,
    objectId: jsonTrack.object_id,
    status: <TrackStatus>jsonTrack.status,
    statusDetails: jsonTrack.status_details,
    statusDate: jsonTrack.status_date,
    location: jsonTrack.location
      ? {
          city: jsonTrack.location.city,
          state: jsonTrack.location.state,
          zip: jsonTrack.location.zip,
          country: jsonTrack.location.country,
        }
      : undefined,
  };
}

export default Track;
export {
  JSONTrack,
  fromJSON,
  TrackStatus,
  transactionSearchTrackFromJSON,
  JSONTransactionSearchTrack,
  TransactionSearchTrack,
};
